import { render, staticRenderFns } from "./ButtonIndex.vue?vue&type=template&id=2f13b205&scoped=true&"
import script from "./ButtonIndex.vue?vue&type=script&lang=js&"
export * from "./ButtonIndex.vue?vue&type=script&lang=js&"
import style0 from "./ButtonIndex.vue?vue&type=style&index=0&id=2f13b205&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f13b205",
  null
  
)

export default component.exports